import React, { Component } from 'react'
import { render } from 'react-dom'
import { getParams, getLang} from '../../common/utils'
import TqcodePurchaseXLVIP from './TqcodePurchaseXLVIP'
import OpensalePurchaseV3 from './OpensalePurchaseV3'
import OpensalePurchaseHK from './OpensalePurchaseHK'

class Index extends Component {
	constructor(props){
		super(props)
		this.params = {
			type: getParams('type') || 'opensale',
			channel: +getParams('channel') || 1,
			lang: getLang()
		}
		const {type,channel,lang} = this.params;
		this.views = {
			tqcode: channel===2 ? <TqcodePurchaseXLVIP /> : <OpensalePurchaseV3 />,
			opensale: lang == 'cn' ? <OpensalePurchaseV3 /> : <OpensalePurchaseHK />,
		}
		this.state = {
			view: this.views[type] || this.views['opensale'],
		}
	}

	render(){
		const {view} = this.state;
		const {type} = this.params;
		const npClass = ['opensale']
		const className = npClass.indexOf(type)>-1 ? 'np' : '';
		return <div className={className} >
			{view}
		</div>
	}
}

render(<Index />, document.getElementById('purchase'))


// WEBPACK FOOTER //
// ./js/src/pages/Purchase/index.js